module.exports = __webpack_public_path__ + "img/ring_g_e_1_0@2x.b1bca2fe.png";